import { Login } from '@components/Login';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/connect/login')({
  component: Login,
  head: () => ({
    meta: [
      {
        title: 'Login — Brighte',
      },
    ],
  }),
});
